import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=c1ea2c22&scoped=true&"
import script from "./ErrorHandler.vue?vue&type=script&lang=js&"
export * from "./ErrorHandler.vue?vue&type=script&lang=js&"
import style0 from "./ErrorHandler.vue?vue&type=style&index=0&id=c1ea2c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ea2c22",
  null
  
)

export default component.exports